import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

// Import images
import newImg1 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.13.jpeg';
import newImg2 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.14 (1).jpeg';
import newImg3 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.14 (2).jpeg';
import newImg4 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.14.jpeg';
import newImg5 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.15 (1).jpeg';
import newImg6 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.15.jpeg';
import newImg7 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.16 (1).jpeg';
import newImg8 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.16.jpeg';
import newImg9 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.17 (1).jpeg';
import newImg10 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.17.jpeg';
import newImg11 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.18 (1).jpeg';
import newImg12 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.18 (2).jpeg';
import newImg13 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.18.jpeg';
import newImg14 from '../assets/new/WhatsApp Image 2025-10-03 at 07.09.19.jpeg';
import newImg15 from '../assets/new/WhatsApp Image 2025-10-08 at 15.08.14.jpeg';
import newImg16 from '../assets/new/WhatsApp Image 2025-10-08 at 15.08.24.jpeg';
import newImg17 from '../assets/new/WhatsApp Image 2025-10-08 at 15.08.31.jpeg';

const images = [
  { src: newImg1 },
  { src: newImg2 },
  { src: newImg3 },
  { src: newImg4 },
  { src: newImg5 },
  { src: newImg6 },
  { src: newImg7 },
  { src: newImg8 },
  { src: newImg9 },
  { src: newImg10 },
  { src: newImg11 },
  { src: newImg12 },
  { src: newImg13 },
  { src: newImg14 },
  { src: newImg15 },
  { src: newImg16 },
  { src: newImg17 },
];

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const toggleLightbox = (i) => {
    setIndex(i);
    setOpen(!open);
  };

  return (
    <div className="bg-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-extrabold text-center text-gray-900 mb-4">Photo Gallery</h1>
        <p className="text-center text-lg text-gray-600 mb-12">A Glimpse of Our World</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((image, i) => (
            <div key={i} className="group relative" onClick={() => toggleLightbox(i)}>
              <img
                src={image.src}
                alt={image.src.split('/').pop().split('.')[0]}
                title={image.src.split('/').pop().split('.')[0]}
                className="w-full h-64 object-cover rounded-lg shadow-md group-hover:opacity-75 transition-opacity duration-300 cursor-pointer"
              />
              <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg">
                <p className="text-white text-lg font-bold">View Image</p>
              </div>
            </div>
          ))}
        </div>

        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={images}
          index={index}
        />
      </div>
    </div>
  );
};

export default Gallery;
